import { bannerImageSizes, communityContentImageSizes, defaultImageSizes, personalizedRecommendationsImageSizes, productImageSizes, quizImageSizes, resolutionMappingSizes, rewardSummaryImageSizes, teaserImageSizes, } from "../image/constants";
import wrapBannerImageSrc from "../image/helpers/wrapBannerImageSrc";
import wrapCommunityContentImageSrc from "../image/helpers/wrapCommunityContentImageSrc";
import wrapDefaultImageSrc from "../image/helpers/wrapDefaultImageSrc";
import wrapPersonalizedRecommendationsImageSrc from "../image/helpers/wrapPersonalizedRecommendationsImageSrc";
import wrapProductImageImageManagerImageSrc from "../image/helpers/wrapProductImageImageManagerImageSrc";
import wrapProductImageSrc from "../image/helpers/wrapProductImageSrc";
import wrapQuizImageImageSrc from "../image/helpers/wrapQuizImageImageSrc";
import wrapRewardSummaryImageSrc from "../image/helpers/wrapRewardSummaryImageSrc";
import wrapTeaserImageSrc from "../image/helpers/wrapTeaserImageSrc";
export const imageTypes = {
    DEFAULT_IMAGE: 'DEFAULT_IMAGE',
    PRODUCT_IMAGE: 'PRODUCT_IMAGE',
    COMMUNITY_CONTENT_IMAGE: 'COMMUNITY_CONTENT_IMAGE',
    PERSONALIZED_RECOMMENDATIONS_IMAGE: 'PERSONALIZED_RECOMMENDATIONS_IMAGE',
    QUIZ_IMAGE: 'QUIZ_IMAGE',
    BANNER_IMAGE: 'BANNER_IMAGE',
    TEASER_IMAGE: 'TEASER_IMAGE',
    NO_TRANSFORM_IMAGE: 'NO_TRANSFORM_IMAGE',
    REWARD_SUMMARY_IMAGE: 'REWARD_SUMMARY_IMAGE',
    RESELL_IMAGE: 'RESELL_IMAGE',
    RENTALS_LOOK_BOOK_IMAGE: 'RENTALS_LOOK_BOOK_IMAGE',
    HERO_IMAGE: 'HERO_IMAGE',
    UNDEFINED: 'UNDEFINED',
};
export const imageUrlTypeMappings = {
    [imageTypes.DEFAULT_IMAGE]: [defaultImageSizes, wrapDefaultImageSrc],
    [imageTypes.PRODUCT_IMAGE]: [productImageSizes, wrapProductImageSrc],
    [imageTypes.COMMUNITY_CONTENT_IMAGE]: [communityContentImageSizes, wrapCommunityContentImageSrc],
    [imageTypes.PERSONALIZED_RECOMMENDATIONS_IMAGE]: [
        personalizedRecommendationsImageSizes,
        wrapPersonalizedRecommendationsImageSrc,
    ],
    [imageTypes.BANNER_IMAGE]: [bannerImageSizes, wrapBannerImageSrc],
    [imageTypes.TEASER_IMAGE]: [teaserImageSizes, wrapTeaserImageSrc],
    [imageTypes.QUIZ_IMAGE]: [quizImageSizes, wrapQuizImageImageSrc],
    [imageTypes.REWARD_SUMMARY_IMAGE]: [rewardSummaryImageSizes, wrapRewardSummaryImageSrc],
    [imageTypes.RESELL_IMAGE]: [resolutionMappingSizes, wrapProductImageImageManagerImageSrc],
    [imageTypes.RENTALS_LOOK_BOOK_IMAGE]: [
        resolutionMappingSizes,
        wrapProductImageImageManagerImageSrc,
    ],
    [imageTypes.HERO_IMAGE]: [resolutionMappingSizes, wrapProductImageImageManagerImageSrc],
    [imageTypes.UNDEFINED]: [defaultImageSizes, []],
};
//# sourceMappingURL=images.js.map